import { ReactNode } from "react";
import {
  LeftContainer,
  ListItemImageContainer,
  MediaImagesListItemWrapper,
} from "../styles/styles";
import { UploadImageButton } from "./UploadImageButton";
import { Media } from "../types/media";
import { MediaImageItem } from "./MediaImageItem";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

interface MediaImagesListItemProps {
  icon?: ReactNode;
  media: Media;
  images: NewOrExistingFile[];
  onImagesChange: (newImages: NewOrExistingFile[]) => void;
  onUpdate: (image: NewOrExistingFile) => void;
}

export const MediaImagesListItem = ({
  icon,
  images,
  onImagesChange,
  onUpdate,
}: MediaImagesListItemProps) => {
  if (!images) return <></>;

  return (
    <MediaImagesListItemWrapper>
      <UploadImageButton
        existingImages={images}
        onImagesChange={(files) => onImagesChange(files)}
      />
      <LeftContainer>
        <>{icon}</>
      </LeftContainer>
      <ListItemImageContainer>
        {images.map((image, index) => (
          <MediaImageItem
            key={`${image.type}-${index}`}
            image={image}
            index={index}
            onUpdate={onUpdate}
          />
        ))}
      </ListItemImageContainer>
    </MediaImagesListItemWrapper>
  );
};
